import StaticRenderer from "SlidesRenderer/StaticRenderer";

export default function ScreenshotSlidePage() {
  return <StaticRenderer />;
}
